// This file is used to load the custom fabric "classes" to the global fabric namespace. Once this is called,
// the custom fabric objects will be available under "fabric".
// This should be called only once and the rest of the application can interact with fabric normally.

import { fabric } from 'fabric';
import ObjectBase from '@/views/tower/v2/objects/ObjectBase';
import GroupBase from '@/views/tower/v2/objects/GroupBase';
import LabeledRect from '@/views/tower/v2/objects/LabeledRect';
import PolicyRect from '@/views/tower/v2/objects/policy_rect/PolicyRect';
import CustomPolicyRect from '@/views/tower/v2/objects/custom_policy_rect/CustomPolicyRect';
import RectBase from '@/views/tower/v2/objects/policy_rect/RectBase';
import PolicyLabel from '@/views/tower/v2/objects/policy_rect/PolicyLabel';
import PolicyLabels from '@/views/tower/v2/objects/policy_rect/PolicyLabels';
import RetentionContainer from '@/views/tower/v2/objects/policy_rect/RetentionContainer';
import CoverageContainer from '@/views/tower/v2/objects/policy_rect/CoverageContainer';
import LabeledObjectBase from '@/views/tower/v2/objects/LabeledObjectBase';
import TowerCanvas from '@/views/tower/v2/objects/TowerCanvas';
import LegendRect from '@/views/tower/v2/objects/LegendRect';
import TowerScale from '@/views/tower/v2/objects/tower_scale/TowerScale';
import ArrowHead from '@/views/tower/v2/objects/tower_scale/ArrowHead';
import LineBody from '@/views/tower/v2/objects/tower_scale/LineBody';
import TickMark from '@/views/tower/v2/objects/tower_scale/TickMark';

fabric.TowerCanvas = TowerCanvas;
fabric.LabeledRect = LabeledRect;
fabric.PolicyRect = PolicyRect;
fabric.CustomPolicyRect = CustomPolicyRect;
fabric.LabeledObjectBase = LabeledObjectBase;
fabric.RectBase = RectBase;
fabric.PolicyLabels = PolicyLabels;
fabric.PolicyLabel = PolicyLabel;
fabric.RetentionContainer = RetentionContainer;
fabric.CoverageContainer = CoverageContainer;
fabric.LegendRect = LegendRect;
fabric.TowerScale = TowerScale;
fabric.TickMark = TickMark;
fabric.ArrowHead = ArrowHead;
fabric.LineBody = LineBody;
fabric.ObjectBase = ObjectBase;
fabric.GroupBase = GroupBase;
